import { Component, Host, h, Prop, Element, State } from '@stencil/core';

@Component({
    tag: 'sew-ws-product-info',
    styleUrl: 'sew-ws-product-info.scss',
    shadow: false,
})
export class SewWsProductInfo {
    @Element() host: HTMLSewWsProductInfoElement;

    @Prop() headline: string;
    @Prop() text: string;
    @Prop() imgAlt: string;

    @State() hasCta: boolean = false;
    @State() hasAdvantage: boolean = false;
    @State() hasLinks: boolean = false;
    @State() hasInformation: boolean = false;

    private onSlotChanges = () => {
        this.hasCta = !!this.host.querySelector('[slot="cta"]');
        this.hasAdvantage = !!this.host.querySelector('[slot="advantage"]');
        this.hasLinks = !!this.host.querySelector('[slot="links"]');
        this.hasInformation = !!this.host.querySelector('[slot="information"]');
    };

    componentWillLoad() {
        this.onSlotChanges();
    }

    render() {
        return (
            <Host>
                <h1 innerHTML={this.headline}></h1>
                <p innerHTML={this.text}></p>
                <div class="left-area">
                    <div class="image-wrapper">
                        <slot name="picture"></slot>
                    </div>
                    {this.hasInformation && <slot name="information" onSlotchange={this.onSlotChanges} />}
                </div>

                <div class="right-area">
                    {this.hasCta && <slot name="cta" onSlotchange={this.onSlotChanges} />}
                    {this.hasAdvantage && <slot name="advantage" onSlotchange={this.onSlotChanges} />}
                    {this.hasLinks && <slot name="links" onSlotchange={this.onSlotChanges} />}
                </div>
            </Host>
        );
    }
}
